import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "netdataAssistant",
  "use": "netdataAssistant-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"netdataAssistant\"><path fill-rule=\"evenodd\" d=\"M8.302 2.5H1l5.788 11.1h2.8L6.2 6.3h2.102zm1.902 11.068L9.45 8.85h1.85L9.06 2.5h.155c3.195.006 5.783 2.578 5.785 5.751-.005 2.758-2.101 5.024-4.796 5.317\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol